import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CustoMensagemWhatsapp } from '../model/parametros/custo-mensagem-whatsapp.model';

@Injectable({ providedIn: 'root' })
export class CustoMensagemWhatsappService {
  private readonly http = inject(HttpClient);

  private readonly urlBase = `${environment.urlBase}/custo-mensagem-whatsapp`;

  listar(): Observable<CustoMensagemWhatsapp[]> {
    return this.http.get<CustoMensagemWhatsapp[]>(this.urlBase);
  }

  salvar(custo: CustoMensagemWhatsapp): Observable<void> {
    return this.http.post<void>(this.urlBase, custo);
  }

  atualizar(id: number, custo: CustoMensagemWhatsapp): Observable<void> {
    return this.http.put<void>(`${this.urlBase}/${id}`, custo);
  }
}
